import { useCallback } from "react";

import { useRequireDelegation } from "@/hooks/use-require-delegation";
import { useRequireTradingAllowed } from "@/hooks/use-require-trading-allowed";

/**
 * Composes `requireTradingAllowed` and `requireDelegation` into a single guard.
 * Checks geoblocking first, then delegation.
 */
export const useRequireTrading = () => {
  const requireTradingAllowed = useRequireTradingAllowed();
  const requireDelegation = useRequireDelegation();

  return useCallback(
    (callback: () => void) => requireTradingAllowed(requireDelegation(callback)),
    [requireTradingAllowed, requireDelegation],
  );
};
